import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './TermsOfService.css'

export default function TermsOfService() {
    return (
        <div>
            <Navbar/>
            <div id = "terms-of-service" style = {{width: '80vw', maxWidth: '1000px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left', marginTop: '100px', marginBottom: '100px'}}>
                <h1>Terms of Service</h1><br></br>
                <p>Effective Date: 12/20/2024</p><br></br>
                <p>Welcome to KC Social Nest ("we," "our," "us"). 
                    These Terms of Service ("Terms") govern your use of the KC Social Nest 
                    chatbot service ("Service"). By accessing or using the Service, 
                    you agree to comply with and be bound by these Terms. If you do not 
                    agree to these Terms, please do not use the Service
                </p>

                <h2>Use of the Service</h2>
                <ul>
                    <li>The Service is provided solely for informational purposes to assist users in finding clinical resources.</li>
                    <li>You agree to use the Service only for lawful purposes and in compliance with all applicable laws and regulations.</li>
                    <li>You must not misuse the Service, including but not limited to attempting to gain unauthorized access, introducing malicious software, or using the Service in a manner that disrupts its functionality.</li>
                </ul>

                <h2>Temporary Data Storage</h2>
                <ul>
                    <li>Conversation data is temporarily stored during your session to provide accurate responses. This data is automatically deleted after 30 days.</li>
                    <li>KC Social Nest does not store any personally identifiable information (PII) or retain data beyond the temporary session storage period.</li>
                </ul>

                <h2>External Services and APIs</h2>
                <p>
                    The service uses third-party APIs, including:
                    <ul>
                        <li>OpenAI API: For natural language processing to understand and respond to user queries.</li>
                        <li>Llama Index API: For retrieving clinical resource information from an external database.</li>
                    </ul>
                    These third-party services are essential for the functionality of the Service, and their use is governed by their respective terms and policies.
                </p>

                <h2>No Medical Advice</h2>
                <ul>
                    <li>The information provided by KC Social Nest is for informational purposes only and is not a substitute for professional medical advice, diagnosis, or treatment.</li>
                    <li>Always seek the advice of a qualified healthcare provider with any questions you may have regarding medical conditions or resources.</li>
                </ul>

                <h2>Limitation of Liability</h2>
                <ul>
                    <li>The Service is provided "as is" and "as available," without warranties of any kind, either express or implied.</li>
                    <li>We do not guarantee the accuracy, completeness, or reliability of the information provided through the Service.</li>
                    <li>To the maximum extent permitted by law, KC Social Nest shall not be liable for any damages, including but not limited to direct, indirect, incidental, or consequential damages, arising from the use or inability to use the Service</li>
                </ul>

                <h2>User Responsibilities</h2>
                <ul>
                    <li>You are responsible for ensuring that your use of the Service complies with these Terms.</li>
                    <li>You must not use the Service in a way that harms or interferes with other users or the operation of the Service.</li>
                </ul>

                <h2>Modifications to the Service and Terms</h2>
                <ul>
                    <li>We reserve the right to modify, suspend, or discontinue the Service at any time without notice.</li>
                    <li>We may update these Terms from time to time. Any changes will be effective immediately upon posting the revised Terms. Your continued use of the Service constitutes acceptance of the updated Terms.</li>
                </ul>

                <h2>Termination</h2>
                <p>We reserve the right to terminate or suspend your access to the Service if you violate these Terms or engage in any conduct that we determine to be harmful, unlawful, or inappropriate.</p>

                <h2>Governing Law</h2>
                <p>These Terms are governed by and construed in accordance with the laws of Kansas City, Missouri, without regard to its conflict of laws principles.</p>

                <h2>Contact Us</h2>
                <p>If you have any questions about these Terms or the Service, please contact us at: admin@kcsocialnest.com</p>
                <p>Thank you for using KC Social Nest.</p>
            </div>
            <Footer/>
        </div>
    )
}